import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableFooter,
  TableBody,
  FormGroup
} from "@mui/material";

const FormElectricityPDF = ({
    elecData,
    checked,
    elecItems
}) => {
    if (!elecData) return null;
    const isNoApplyO5 = [elecData?.o5?.[0]?.exhibitor_status ?? elecData?.exhibitor_status]
                       .every(s => s === "申請しない");

    const isNoApplyO6 = [elecData?.o6?.[0]?.exhibitor_status ?? elecData?.exhibitor_status]
                        .every(s => s === "申請しない");
  return (
    <div>
       <Container>
        <Box>
            <Typography variant="h6">メッセナゴヤ出展者　マイページ情報</Typography>
            {elecData ? (
            <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                <Typography variant="body1">小間番号: {elecData?.booth_number}</Typography>
                <Typography variant="body1">出展者名: {elecData?.company_name}</Typography>
                <Typography variant="body1">部署: {elecData?.department}</Typography>
                <Typography variant="body1">担当者名: {elecData?.user_name}</Typography>
                <Typography variant="body1">郵便番号: {elecData?.zip_code}</Typography>
                <Typography variant="body1">住所: {elecData?.address}</Typography>
                <Typography variant="body1">電話番号: {elecData?.phone_number}</Typography>
                <Typography variant="body1">メールアドレス: {elecData?.email}</Typography>
            </Box>
            ) : (
            <Typography variant="body2">読み込み中...</Typography>
            )}
        </Box>
        <Container sx={{mt:4}}>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>電気(電力)使用申込</Typography>
            <FormControlLabel
                control={<Checkbox checked={isNoApplyO5} readOnly />}
                label="申請しない"
            />
            <Box>
                {!isNoApplyO5 && (
                <>
                    <Typography variant="h6" gutterBottom>担当者情報</Typography>
                    <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                    <FormControl component="fieldset" sx={{ mt: 2 }}>
                        <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                        <RadioGroup
                        row
                        value={elecData?.o5?.[0]?.same_ex_5}
                        >
                        <FormControlLabel value="same" control={<Radio />} label="同じ" />
                        <FormControlLabel value="different" control={<Radio />} label="異なる" />
                        </RadioGroup>
                    </FormControl>
                    <Box
                        sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                        }}
                    >
                        <Box>氏名</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.user_5_name}</Box>
                        <Box>部署</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.user_5_department}</Box>
                        <Box>会社電話番号</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.user_5_phone}</Box>
                        <Box>携帯電話番号</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.user_5_tel}</Box>
                    </Box>

                    <Typography variant="h6" gutterBottom>
                    請求先情報
                    </Typography>
                    <FormControl component="fieldset">
                    <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                    <RadioGroup row value={elecData?.o5?.[0]?.same_in_5}>
                        <FormControlLabel value="same" control={<Radio />} label="同じ" />
                        <FormControlLabel value="different" control={<Radio />} label="異なる" />
                    </RadioGroup>
                    </FormControl>
                    <Box
                        sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                        }}
                    >
                        <Box>請求先会社名</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_company_name}</Box>
                        <Box>請求担当者名</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_user_name}</Box>
                        <Box>請求先メールアドレス</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_email}</Box>
                        <Box>郵便番号</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_zip}</Box>
                        <Box>請求先住所</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_address}</Box>
                        <Box>電話番号</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_tel}</Box>
                        <Box>FAX番号</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.invoice_fax}</Box>
                    </Box>

                    <Typography variant="h6" sx={{ mt: 4 }}>必要電気容量</Typography>

                    <FormGroup row>
                        <FormControlLabel
                        control={<Checkbox name="v100" checked={!!checked.v100} />}
                        label="100V機器を希望する"
                        />
                        <FormControlLabel
                        control={<Checkbox name="v200" checked={!!checked.v200} />}
                        label="200V機器を希望する"
                        />
                    </FormGroup>

                    <Grid container spacing={2}>
                        {checked.v100 && (
                        <>
                        <Box>100V容量（W）</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.quantity_100v ?? ""}</Box>
                        </>
                        )}

                        {checked.v200 && (
                        <>
                        <Box>200V容量（W）</Box><Box sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid #999",
                        }}>{elecData?.o5?.[0]?.quantity_200v ?? ""}</Box>
                        </>
                        )}

                        {(checked.v100 || checked.v200) && (
                        <Grid size={12} sm={4}>
                            <Typography>
                            総合計容量： {elecData?.o5?.[0]?.quantity_all ?? 0} W
                            </Typography>
                        </Grid>
                        )}
                    </Grid>

                    <Grid container spacing={2}>
                        {checked.v100 && (
                        <Grid size={12}>
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={elecData?.o5?.[0]?.quantity_100v || false}
                            />
                            }
                            label="100V終夜送電"
                        />
                        </Grid>
                        )}
                        {checked.v200 && (
                        <Grid size={12}>
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={elecData?.o5?.[0]?.quantity_200v || false}
                            />
                            }
                            label="200V終夜送電"
                        />
                        </Grid>
                        )}
                    </Grid>

                    {checked.v100 && (
                    <>
                    <Typography variant="h6" sx={{ mt: 4 }}>100v機器の詳細</Typography>
                    {elecData?.o5?.[0]?.details_100?.map((row, i) => (
                    <div key={i}>
                        <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "120px 1fr 120px 1fr",
                            gap: "4px 12px",
                            fontSize: "12px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                        }}
                        >
                            <Box>機器名</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.device_100_name}</Box>
                            <Box>容量</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.quantity_100}</Box>
                            <Box>数量</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.number_100}</Box>
                            <Box>合計</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.total_100}</Box>
                            <Box>備考</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.ex_100}</Box>
                        </Box>
                    </div>
                    ))}
                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    合計（100V）：{
                        elecData?.o5?.[0]?.details_100?.reduce((sum, row) => {
                        const q = Number(row.quantity_100) || 0;
                        const n = Number(row.number_100) || 0;
                        return sum + q * n;
                        }, 0)
                    } W
                    </Typography>
                    </>
                    )}

                    {checked.v200 && ( 
                    <>
                    <Typography variant="h6" sx={{ mt: 4 }}>200v機器の詳細</Typography>
                    {elecData?.o5?.[0]?.details_200?.map((row, i) => (
                    <div key={i}>
                        <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "120px 1fr 120px 1fr",
                            gap: "4px 12px",
                            fontSize: "12px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                        }}
                        >
                            <Box>機器名</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.device_200_name}</Box>
                            <Box>容量</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.quantity_200}</Box>
                            <Box>数量</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.number_200}</Box>
                            <Box>合計</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.total_200}</Box>
                            <Box>備考</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{row.ex_200}</Box>
                        </Box>
                    </div>
                    ))}
                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    合計（200V）：{
                        elecData?.o5?.[0]?.details_200?.reduce((sum, row) => {
                        const q = Number(row.quantity_200) || 0;
                        const n = Number(row.number_200) || 0;
                        return sum + q * n;
                        }, 0)
                    } W
                    </Typography>
                    </>
                    )}

                    {/* <Box>
                        <FormControl component="fieldset">
                        <RadioGroup
                            row
                            value={elecData?.o5?.[0]?.overnight ? "true" : "false"}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="24時間送電あり" />
                            <FormControlLabel value="false" control={<Radio />} label="24時間送電なし" />
                        </RadioGroup>
                        </FormControl>
                    </Box> */}

                    <Typography variant="h6" sx={{ mt: 4 }}>小間内電気工事</Typography>
                    <Grid container spacing={2}>
                        <FormControl component="fieldset">
                        <FormLabel component="legend">自社で依頼している電気工事の委託業者がありますか？</FormLabel>
                        <RadioGroup
                        row
                        value={elecData?.o5?.[0]?.elec_select === true ? 'true' : 'false'}
                        >
                        <FormControlLabel value="true" control={<Radio />} label="ある" />
                        <FormControlLabel value="false" control={<Radio />} label="ない" />
                        </RadioGroup>
                        </FormControl>

                        {/* trueのときのみ委託会社情報を表示 */}
                        {elecData?.o5?.[0]?.elec_select === true && (
                        <>
                        <Typography>自社で依頼している電気工事の委託会社情報をご入力ください。</Typography>
                        <Box
                            sx={{
                            display: "grid",
                            gridTemplateColumns: "120px 1fr 120px 1fr",
                            gap: "4px 12px",
                            fontSize: "12px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                            }}
                        >
                            <Box>業者名</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_company_name}</Box>
                            <Box>郵便番号</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_zip}</Box>
                            <Box>住所</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_address}</Box>
                            <Box>担当者名</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_user_name}</Box>
                            <Box>電話番号</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_tel}</Box>
                            <Box>FAX番号</Box><Box sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                borderRight: "1px solid #999",
                            }}>{elecData?.o5?.[0]?.elec_fax}</Box>
                        </Box>
                        </>
                        )}
                    </Grid>

                    <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                    <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {elecData?.o5?.[0]?.alfa_text}
                    </Typography>
                </>
                )}
            </Box>

            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', mx: 'auto', my: 4}}>電気備品レンタル申込</Typography>
            <Box>
                <FormControlLabel
                    control={<Checkbox checked={isNoApplyO6} readOnly />}
                    label="申請しない"
                />
                {!isNoApplyO6 && (
                <>
                <Typography variant="h6" gutterBottom>担当者情報</Typography>
                <FormControl component="fieldset" sx={{ mt: 2 }}>
                    <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                    <RadioGroup
                    row
                    value={elecData?.o6?.[0]?.same_ex_6}
                    >
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                    </RadioGroup>
                </FormControl>
                <Box
                    sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                    }}
                >
                    <Box>氏名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.user_6_name}</Box>
                    <Box>部署</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.user_6_department}</Box>
                    <Box>会社電話番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.user_6_phone}</Box>
                    <Box>携帯電話番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.user_6_tel}</Box>
                </Box>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={elecData?.o6?.[0]?.same_in_6}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Box
                    sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                    }}
                >
                    <Box>請求先会社名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_company_name}</Box>
                    <Box>請求担当者名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_user_name}</Box>
                    <Box>請求先メールアドレス</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_email}</Box>
                    <Box>郵便番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_zip}</Box>
                    <Box>請求先住所</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_address}</Box>
                    <Box>電話番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_tel}</Box>
                    <Box>FAX番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{elecData?.o6?.[0]?.invoice_fax}</Box>
                </Box>

                <Typography variant="h6" sx={{ mt: 4 }}>電気備品一覧</Typography>
                <Box>
                    <Table size="small">
                    <TableHead>
                        <TableRow>
                        <TableCell>品番</TableCell>
                        <TableCell>品名</TableCell>
                        <TableCell>単価(税込)</TableCell>
                        <TableCell>数量</TableCell>
                        <TableCell>合計</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {elecItems.map((item) => {
                        const detail = elecData?.o6?.[0]?.details?.find(d => d.elec_item_id === item.elec_item_id);
                        const number = detail?.number || 0;
                        const unitTotal = item.unit_price * number;

                        if (number <= 0) return null;

                        return (
                            <TableRow key={item.elec_item_id}>
                            <TableCell>
                                <Typography sx={{ fontFamily: 'monospace' }}>{item.elec_item_id}</Typography>
                            </TableCell>
                            <TableCell>{item.elec_item_name}</TableCell>
                            <TableCell>¥{item.unit_price.toLocaleString()}</TableCell>
                            <TableCell>
                                <TextField
                                value={number}
                                size="small"
                                fullWidth
                                onWheel={(e) => e.target.blur()}
                                />
                            </TableCell>
                            <TableCell>¥{unitTotal.toLocaleString()}</TableCell>
                            </TableRow>
                        );
                        })}
                    </TableBody>
                    <TableFooter>
                    <TableRow>
                        <TableCell colSpan={4} align="right">
                        <Typography variant="subtitle1">総合計金額:</Typography>
                        </TableCell>
                        <TableCell>
                        <Typography variant="subtitle1">
                            ¥{(elecData?.o6?.[0]?.elec_total ?? 0).toLocaleString()}
                        </Typography>
                        </TableCell>
                    </TableRow>
                    </TableFooter>
                    </Table>
                </Box>

                <Typography>その他備品 : {elecData?.o6?.[0]?.other_items}</Typography>

                <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {elecData?.o6?.[0]?.alfa_text}
                </Typography>
                </>
                )}
            </Box>
        </Container>
      </Container>
    </div>
  );
};

export default FormElectricityPDF;
